document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('[data-countdown]').forEach(function(el) {
    var hours = parseInt(el.getAttribute('data-countdown-hours') || '4', 10);
    var end = new Date().getTime() + hours * 60 * 60 * 1000;
    var target = el.querySelector('[data-countdown-target]');
    if (!target) return;
    function tick() {
      var now = new Date().getTime();
      var diff = Math.max(end - now, 0);
      var h = Math.floor(diff / (1000 * 60 * 60));
      var m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      var s = Math.floor((diff % (1000 * 60)) / 1000);
      target.textContent = h + 'h ' + m + 'm ' + s + 's';
      if (diff <= 0) return;
      requestAnimationFrame(tick);
    }
    tick();
  });
  var sticky = document.querySelector('[data-sticky-atc]');
  if (sticky) {
    var threshold = 400;
    window.addEventListener('scroll', function() {
      if (window.scrollY > threshold) {
        sticky.style.display = 'block';
      } else {
        sticky.style.display = 'none';
      }
    });
  }
});